module.exports = __webpack_public_path__ + "static/logo_acquario_genova-54ba8d061207bc9524c6b1a2183a7922.png";